/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Å odien',
  now: 'Tagad',
  backToToday: 'AtpakaÄ¼ pie Å¡odienas',
  ok: 'Ok',
  clear: 'Skaidrs',
  month: 'MÄnesis',
  year: 'Gads',
  timeSelect: 'IzvÄlieties laiku',
  dateSelect: 'IzvÄlieties datumu',
  monthSelect: 'IzvÄlieties mÄnesi',
  yearSelect: 'IzvÄlieties gadu',
  decadeSelect: 'IzvÄlieties desmit gadus',
  yearFormat: 'YYYY',
  dateFormat: 'D.M.YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D.M.YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'IepriekÅ¡Äjais mÄnesis (PageUp)',
  nextMonth: 'NÄkammÄnes (PageDown)',
  previousYear: 'PagÄjuÅ¡ais gads (Control + left)',
  nextYear: 'NÄkamgad (Control + right)',
  previousDecade: 'PÄdÄjÄ desmitgadÄ',
  nextDecade: 'NÄkamÄ desmitgade',
  previousCentury: 'PagÄjuÅ¡ajÄ gadsimtÄ',
  nextCentury: 'NÄkamajÄ gadsimtÄ'
};
